import React from 'react';

export default function ConversationFilterBar({ filters, value, onChange, counts = {} }) {
  return (
    <div className="bam-filter-bar" role="tablist" aria-label="Filter conversations">
      {filters.map((f) => {
        const count = counts[f.value];
        const active = value === f.value;
        return (
          <button
            key={f.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`bam-filter-pill${active ? ' is-active' : ''}`}
            onClick={() => onChange(f.value)}
          >
            <span>{f.label}</span>
            {count > 0 && (
              <span className="bam-filter-pill-count">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
